module.exports = __webpack_public_path__ + "img/wuliu.50f52728.jpg";